import React from 'react';

import { Button, type ButtonProps } from './Button';

export type ButtonDestructiveProps = Omit<ButtonProps, 'variant'>;

/**
 * Bouton d’action destructive (perte de données définitive).
 * Spécification : fond `surface.error.default`, texte sur couleur, états via calques inverses.
 */
export function ButtonDestructive(props: ButtonDestructiveProps) {
  return <Button {...props} variant="destructive" />;
}
